define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({
    validation: {
      username: {
        required: true
      },
      contactId:{
        addressLine1:{
          maxLength:40
        },
        addressLine2:{
          maxLength:40
        },
        city:{
          maxLength:30
        },
        state:{
          maxLength:30
        },
        postalCode:{
          maxLength:30,
        },
        eMailAddress:{
          maxLength:50,
          pattern:'email'
        },
        dayPhone:{
          maxLength:30,
        },
        faxNumber:{
          maxLength:30,
        },
        identity: {
          lastName:{
            required: true,
            maxLength:50,
          },
          firstName:{
            maxLength:35,
          },
          middleName:{
            maxLength:35,
          },
          title:{
            maxLength:35,
          }
        }
      }
    },
    urlRoot: '/delegate/civics-api/api/portal/users'
  });
});
